const MStudent = [
  {
    title: 'Student Portal',
    is_heading: true,
    is_active: false,
    link: {
      name: 'student.dashboard'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-graduation-cap',
    active_icon: 'fad fa-graduation-cap'
  },
  {
    title: 'Dashboard',
    is_heading: false,
    is_active: false,
    link: {
      name: 'student.dashboard'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-objects-column',
    active_icon: 'fad fa-objects-column'
  },
  {
    title: 'Services',
    is_heading: true,
    is_active: false,
    link: {
      name: 'student.dashboard'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-clipboard-list',
    active_icon: 'fad fa-clipboard-list'
  },
  {
    title: 'Appointments',
    is_heading: false,
    is_active: false,
    link: {
      name: 'student.appointments'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-calendar-check',
    active_icon: 'fad fa-calendar-check'
  },
  {
    title: 'Lost & Found',
    is_heading: false,
    is_active: false,
    link: {
      name: 'student.lost-and-found'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-search-location',
    active_icon: 'fad fa-search-location'
  },
  {
    title: 'Violations',
    is_heading: false,
    is_active: false,
    link: {
      name: 'student.violations'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-exclamation-triangle',
    active_icon: 'fad fa-exclamation-triangle'
  },
  {
    title: 'Complaints',
    is_heading: false,
    is_active: false,
    link: {
      name: 'student.complaints'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-file-alt',
    active_icon: 'fad fa-file-alt'
  },
  {
    title: 'Counseling Chat',
    is_heading: false,
    is_active: false,
    link: {
      name: 'student.counseling-chat'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-comments',
    active_icon: 'fad fa-comments'
  },
  {
    title: 'Feedback',
    is_heading: false,
    is_active: false,
    link: {
      name: 'student.feedback'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-comment-dots',
    active_icon: 'fad fa-comment-dots'
  },
  {
    title: 'Account',
    is_heading: true,
    is_active: false,
    link: {
      name: 'student.dashboard'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-cog',
    active_icon: 'fad fa-cog'
  },
  {
    title: 'Account Settings',
    is_heading: false,
    is_active: false,
    link: {
      name: 'student.settings'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-user-cog',
    active_icon: 'fad fa-user-cog'
  }
]

export default MStudent
